/**
 *
 * Search Service
 *
 */
import { FAILURE, LOADING, NAMESPACE, NOT_ASKED, TRANSFER_DIRECTIONS, TRANSFER_REVIEW_ROLES, TRANSFER_REVIEW_ROLES_PARTIAL, TRANSFER_STATES, TRANSFER_MECHANISMS } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { selectStatus, selectParams, selectResults, selectResultsCount, selectError, searchParams, nextPageToken, previousPageToken, totalSize, selectSearchShowAllFields } from './selectors';
import { searchRequest, updateAlreadyRequestedTransfer } from './actions';
import { parseSearchQueryParams } from './api';

// The searchRequest() constitutes the external API for this service.
// Calling this function initiates a request.
export {
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  parseSearchQueryParams,
  reducer,
  sagas,
  selectStatus,
  selectParams,
  selectResults,
  selectResultsCount,
  selectError,
  selectSearchShowAllFields,
  searchRequest,
  updateAlreadyRequestedTransfer,
  TRANSFER_DIRECTIONS,
  TRANSFER_STATES,
  TRANSFER_MECHANISMS,
  TRANSFER_REVIEW_ROLES,
  TRANSFER_REVIEW_ROLES_PARTIAL,
  searchParams,
  previousPageToken,
  nextPageToken,
  totalSize,
};



// WEBPACK FOOTER //
// ./src/services/search/index.js